import React from 'react';
import styled from 'styled-components';

const StyledSpacer = styled.div`
  ${({ $width }) => $width !== undefined && `width: ${$width};`}
  ${({ $height }) => $height !== undefined && `height: ${$height};`}
  ${({ $width, $height }) =>
    $width && !$height ? 'display: inline-block;' : 'display: block;'}
  flex-shrink: 0;
`;

const Spacer = ({ width = 0, height = 0 }) => {
  return (
    <StyledSpacer
      $width={width}
      $height={height}
    />
  );
};

export default Spacer;
